import { ExpandMoreRounded } from '@mui/icons-material'
import { Box, TextField, Typography, Accordion, AccordionSummary, AccordionDetails, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'
import PreviewBox from './preview-box'
import { useSelector } from 'react-redux'
import { SkillBiteEditSlice } from '../../../../../../reducers'

export const RESPONSE_TYPES = {
  YES: 'yes',
  NO: 'no'
}
const AccordionResponseForm = ({
  accordionTitle,
  control,
  responseType,
  block,
  blockDataFormIndex
}) => {
  const responseLabels = block?.data?.labels?.[responseType] || {}
  const responseLabelsFormIndex = `${blockDataFormIndex}.labels.${responseType}`
  const radioDefaultLabel = responseType === RESPONSE_TYPES.YES ? 'Yes' : 'No'
  const canEdit = useSelector(SkillBiteEditSlice.selectors.selectEditMode)

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreRounded />}>
        <Typography sx={{ fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}>{accordionTitle}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Controller
            name={`${responseLabelsFormIndex}.complimentaryText`}
            control={control}
            render={({ field }) => (
              <TextField
                sx={{ marginTop: '8px', marginBottom: '8px', width: '100%' }}
                label='Answer Complementary Text'
                disabled={!canEdit}
                {...field}
              />
            )}
          />

          <PreviewBox>
            <RadioGroup
              row
              aria-label='position'
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gridGap: (theme) => theme.spacing(6)
              }}
              name='commitmentAchieved'
            >
              <FormControlLabel
                data-test='commitment-check-achieved-yes'
                control={<Radio color='primary' />}
                checked
                label={<Typography><strong>{radioDefaultLabel}</strong>{responseLabels.complimentaryText}</Typography>}
                labelPlacement='end'
              />
            </RadioGroup>
          </PreviewBox>

          <Controller
            name={`${responseLabelsFormIndex}.title`}
            control={control}
            render={({ field }) => (
              <TextField
                sx={{ marginTop: '32px', marginBottom: '8px', width: '100%' }}
                label='Answer Header'
                disabled={!canEdit}
                {...field}
              />
            )}
          />

          <Controller
            name={`${responseLabelsFormIndex}.message`}
            control={control}
            render={({ field }) => (
              <TextField
                sx={{ marginTop: '8px', marginBottom: '8px', width: '100%' }}
                label='Answer Text'
                disabled={!canEdit}
                {...field}
              />
            )}
          />

          <Controller
            name={`${responseLabelsFormIndex}.reviewLabel`}
            control={control}
            render={({ field }) => (
              <TextField
                sx={{ marginTop: '8px', marginBottom: '8px', width: '100%' }}
                label='Commitment Check Label'
                disabled={!canEdit}
                {...field}
              />
            )}
          />
          <PreviewBox>
            <Box
              display='flex'
              flex={1}
              flexDirection='column'
              data-test='commitment-check-review-container'
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '24px',
                  lineHeight: '32px'
                }}
              >
                {responseLabels.title}
              </Typography>
              <Typography
                sx={{
                  marginTop: (theme) => theme.spacing(2)
                }}
              >
                {responseLabels.message}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  marginTop: (theme) => theme.spacing(6),
                  marginBottom: (theme) => theme.spacing(2)
                }}
              >
                {responseLabels.reviewLabel}
              </Typography>
              <TextField
                id={`commitment-check-${block.id}`}
                multiline
                disabled
                variant='outlined'
                minRows={4}
                placeholder='Type here...'
              />
            </Box>
          </PreviewBox>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionResponseForm
